export const ROOT = 'flashMessage';

export const OPEN_FLASH_MESSAGE = `${ROOT}/OPEN_FLASH_MESSAGE`;
export const CLOSE_FLASH_MESSAGE = `${ROOT}/CLOSE_FLASH_MESSAGE`;
